/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { Log, LogFromJSON, LogFromJSONTyped, LogToJSON } from "./Log";

/**
 *
 * @export
 * @interface LogListResponse
 */
export interface LogListResponse {
  /**
   *
   * @type {number}
   * @memberof LogListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof LogListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof LogListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof LogListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof LogListResponse
   */
  count: number;
  /**
   *
   * @type {Array<Log>}
   * @memberof LogListResponse
   */
  data: Array<Log>;
}

export function LogListResponseFromJSON(json: any): LogListResponse {
  return LogListResponseFromJSONTyped(json, false);
}

export function LogListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(LogFromJSON),
  };
}

export function LogListResponseToJSON(value?: LogListResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(LogToJSON),
  };
}
